import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Analytics from "analytics/util/Analytics";
import formattedCameFromParam from "analytics/util/cameFrom";
import { getValueForPromoDesign } from "analytics/util/queryParamsMap";
import { getQuery } from "analytics/util/helpers";
import WindowShade from "shared/payment/components/WindowShade";
import ProductPackageScreen from "../ProductPackageScreen";

import "./index.scss";

const Boosts = ({
	isVisible,
	productPackages,
	close,
	fetchProductPackages,
}) => {
	useEffect(() => {
		if (isVisible) {
			fetchProductPackages();

			const cameFrom = formattedCameFromParam("boost");
			const promoDesignQuery = getQuery("pd");
			const promoDesignEventAttr = promoDesignQuery
				? getValueForPromoDesign(promoDesignQuery)
				: null;

			Analytics.logUIEvent(
				Analytics.eventNames.viewedRateCard,
				{
					data: {
						"feature": "boost",
						"feature type": "token",
						"token package mix": productPackages.map((product) => product.tokensNumber).reverse().join(", "),
						"total token package price": productPackages.map((product) => product.initialPrice / 100).reverse().join(", "),
						"came from": cameFrom,
						"promo id": cameFrom,
						"promo design": promoDesignEventAttr,
					},
				},
			);
		}
		// eslint-disable-next-line
	}, [isVisible]);

	return (
		<WindowShade
			isVisible={isVisible}
			toggleVisible={close}
		>
			<ProductPackageScreen />
		</WindowShade>
	);
};


Boosts.propTypes = {
	productPackages: PropTypes.array.isRequired,
	isVisible: PropTypes.bool.isRequired,

	close: PropTypes.func.isRequired,
	fetchProductPackages: PropTypes.func.isRequired,
};

export default Boosts;



// WEBPACK FOOTER //
// ./src/apps/boosts/components/Desktop/index.jsx